import { render } from "./ReportesGas.vue?vue&type=template&id=5cbc33b2&scoped=true"
import script from "./ReportesGas.vue?vue&type=script&lang=js"
export * from "./ReportesGas.vue?vue&type=script&lang=js"

import "./ReportesGas.vue?vue&type=style&index=0&id=5cbc33b2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cbc33b2"]])

export default __exports__